import { parseHtml } from '../core/utils';
import { useTranslation } from '../core/utils/translations';
import { ContentWrapper } from '../components/content-wrapper';
import { PageWrapper } from '../components/page-wrapper';

export function DataProtection() {
  const { t } = useTranslation('legal-pages');

  return (
    <PageWrapper>
      <ContentWrapper>
        <div className="pwa-content">{parseHtml(t('data-protection'))}</div>
      </ContentWrapper>
    </PageWrapper>
  );
}
